// Modify uploaded sweeps for barriers to affect them
import { CombinedSweep, NavigationSweep } from '@/components/util/sdk/sweep/types';
import { checkIntersection } from '@/utils/three/checkIntersection';

export const getPathCalculationSweeps = (
  allSweeps: Map<string, CombinedSweep>,
  barriers,
  sceneBarrierNodes,
  onSweepsIntersectedByBarrier?,
) => {
  if (!allSweeps) return;

  const modifiedSweeps = new Map(allSweeps);
  const enabledSceneBarriers = new Map();
  if (barriers)
    barriers.forEach((barrier: any) => {
      if (barrier.id === undefined) return;
      const node = sceneBarrierNodes.find((node) => node[1].originId === barrier.id);
      if (node && barrier.enabled) enabledSceneBarriers.set(barrier.id, node);
    });

  enabledSceneBarriers.forEach((barrierNode) => {
    barrierNode[0].obj3D.updateMatrixWorld(true);
  });

  modifiedSweeps.forEach((sweep) => {
    if (!sweep.neighbourSweeps) return;

    const neighborSweeps = sweep.neighbourSweeps.reduce((acc: any, neighborId) => {
      const neighbor = modifiedSweeps.get(neighborId);
      if (neighbor) return [...acc, neighbor];
      return acc;
    }, []);
    const modifiedSweep = {
      ...sweep,
      neighbourSweeps: [...(sweep.neighbourSweeps || [])],
    };
    const idsToRemove: string[] = [];

    neighborSweeps.forEach((neighborSweep: CombinedSweep) => {
      // Apply barrier changes
      enabledSceneBarriers.forEach((barrierNode) => {
        const intersects = checkIntersection(
          sweep,
          neighborSweep,
          barrierNode[0].obj3D,
          barrierNode[1].context.scene,
        );

        if (intersects.length) {
          let isBarrierFront = false;
          intersects.every((i) => {
            if (i.object.name === 'barrierFront' && i.object.visible) {
              isBarrierFront = true;
              return false;
            }
            if (i.object.name === 'barrierBack' && i.object.visible) {
              return false;
            }
            return true;
          });
          if (isBarrierFront) return;

          if (!neighborSweep.isCustom && !sweep.isCustom && onSweepsIntersectedByBarrier) {
            onSweepsIntersectedByBarrier(sweep, neighborSweep);
          }
          idsToRemove.push(neighborSweep.id);
        }
      });
    });

    modifiedSweep.neighbourSweeps = modifiedSweep.neighbourSweeps.filter(
      (s) => !idsToRemove.includes(s),
    );

    modifiedSweeps.set(modifiedSweep.id, modifiedSweep);
  });

  return modifiedSweeps;
};

export const getSweepSid = (sweep) => {
  return sweep.sid ? sweep.sid : sweep.sweep;
};

export const getEuclidianDistance = (
  point1: Pick<NavigationSweep, 'positionX' | 'positionY' | 'positionZ' | 'isCustom'>,
  point2: Pick<NavigationSweep, 'positionX' | 'positionY' | 'positionZ' | 'isCustom'>,
) => {
  return Math.sqrt(
    Math.pow(point2.positionX - point1.positionX, 2) +
      Math.pow(point2.positionY - point1.positionY, 2) +
      Math.pow(point2.positionZ - point1.positionZ, 2),
  );
};
